@use "styles" as *;
@use "sass:map";
@use "~swiper/swiper-bundle.min.css";

$block: me-slider;

.#{$block} {
  display: block;

  &__button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: space(2, 0.5);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &--disabled,
    .#{$block}--disabled-navigation & {
      display: none;
    }

    &--prev {
      border-top-right-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
      left: 0;
    }

    &--next {
      border-top-left-radius: $border-radius;
      border-bottom-left-radius: $border-radius;
      right: 0;
    }

    i {
      line-height: 1;
    }
  }

  @each $theme, $theme-options in $slider-themes {
    &--#{$theme} {
      --swiper-theme-color: #{map.get($theme-options, pagination-color)};
      --swiper-pagination-bullet-inactive-color: #{map.get($theme-options, pagination-color)};
      --swiper-pagination-bullet-inactive-opacity: #{map.get($theme-options, pagination-inactive-opacity)};

      .#{$block}__button {
        background: map.get($theme-options, navigation-background);
        color: map.get($theme-options, navigation-color);
      }
    }
  }

  &--collection {
    margin: -$me-section-collection-box-shadow-offset 0;

    .swiper-slide {
      width: $me-slider-collection-slide-width;
      margin: $me-section-collection-box-shadow-offset $me-section-collection-slide-margin-horizontal;

      &:not(:last-child) {
        margin-right: calc(4 * $space - $me-section-collection-box-shadow-offset);
      }
    }
  }

  &--detail-images {
    @include media-breakpoint-down(sm) {
      .#{$block}__button {
        top: 25vw;
      }
    }
  }

  &:not(&--disabled-pagination) {
    padding-bottom: space(5);

    .#{$block}__pagination {
      bottom: 0;
    }

    .#{$block}__button {
      top: calc(50% - #{space(2.5)});
    }
  }

  .me-teaser {
    border-bottom: 0;
  }

  &--equal-heights {
    .swiper-slide {
      height: auto;

      > * {
        height: 100%;
      }
    }
  }
}
